// extracted by mini-css-extract-plugin
module.exports = {"splash":"Splash_splash__14-nN","splash__logo":"Splash_splash__logo__2eWVi","spin":"Splash_spin__2kNnW"};